import React, { useReducer, useState, useRef } from 'react'
import InvisibleRecaptcha from 'src/components/InvisibleRecaptcha'

import Form   from './Form'
import SignIn from './SignIn'

import csrfHeaders from 'src/utils/csrfHeaders'

const reducer = (state, action) => {
  switch (action.type) {
    case 'setFieldValue':
      return { ...state, [action.field]: action.value }
    default:
      throw new Error('Invalid reducer action')
  }
}

const App = ({
  recaptchaSiteKey, signInUrl, submitUrl, partner_key, external_id, logged_in,
  organizer_create, disable_form, profile_picture, p2p_custom_message, imageUpload, omni,
}) => {
  const [ state, dispatch ] = useReducer(reducer, { p2p_custom_message, profile_picture })
  const [ errors, setErrors ] = useState({})
  const [ signIn, setSignIn ] = useState(false)
  const [ loading, setLoading ] = useState(false)

  const recaptcha = useRef()

  const toggleSignIn = e => {
    e.preventDefault()
    setSignIn(signIn => !signIn)
  }

  const inputProps = fullId => {
    const id = fullId.split('.').at(-1)
    return {
      id: fullId,
      value: state[id] || '',
      error: errors?.[fullId]?.[0],
      onChange (e) {
        dispatch({ type: 'setFieldValue', field: id, value: e.target.value })
        setErrors(errors => ({ ...errors, [fullId]: null }))
      },
    }
  }

  const submitForm = async token => {
    if (loading) return
    setLoading(true)

    try {
      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: csrfHeaders(),
        body: JSON.stringify({
          'g-recaptcha-response': token,
          partner_key,
          external_id,
          organizer_create,
          fundraiser: state,
        })
      })
      const json = await response.json()
      if (response.ok)
        top.location.href = json.redirect_url
      else
        setErrors(json.errors)
    } catch (error) {
      setErrors({ base: [ 'Something went wrong. Please try again' ] })
    } finally {
      setLoading(false)
      recaptcha.current?.reset()
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (recaptcha.current)
      recaptcha.current.execute()
    else
      submitForm()
  }

  return signIn
  ? <SignIn
      loading={loading}
      setLoading={setLoading}
      signInUrl={signInUrl}
      toggleSignIn={toggleSignIn}
      omni={omni}
    />
  : <Form
      logged_in={logged_in}
      organizer_create={organizer_create}
      disable_form={disable_form}
      loading={loading}
      inputProps={inputProps}
      toggleSignIn={toggleSignIn}
      handleSubmit={handleSubmit}
      imageUpload={imageUpload}
      profile_picture={profile_picture}
      omni={omni}
    >
      {
        (!logged_in && !organizer_create) &&
        <div className="position-relative" style={{ zIndex: 10 }}>
          <InvisibleRecaptcha
            ref={recaptcha}
            sitekey={recaptchaSiteKey}
            onChange={submitForm}
          />
        </div>
      }
    </Form>
}

export default App
